import './App.css';
import './style/css/reset.css'
import './style/css/style.css'
import { Navigate, Route, Routes } from 'react-router-dom'
import Header from './Components/Header';
import Footer from './Components/Footer';
import LeaderboardBatter from './Pages/LeaderboardBatter';
import LeaderboardPitcher from './Pages/LeaderboardPitcher';
import PersonPitcher from './Pages/PersonPitcher';
import useGoogleSheets from 'use-google-sheets';
import PersonBatter from './Pages/PersonBatter';

function App() {
  const auth_data = {
    apiKey: process.env.REACT_APP_GOOGLE_API_KEY,
    sheetId: process.env.REACT_APP_GOOGLE_SHEETS_ID
  }

  const { data, loading } = useGoogleSheets(auth_data)

  return (
    <div className="App">
     <Header />
     <Routes>
       <Route path='/leaderboard-batter' element={<LeaderboardBatter data={data} loading={loading} />} />
       <Route path='/leaderboard-pitcher' element={<LeaderboardPitcher data={data} loading={loading} />} />
       <Route path='/personal-pitcher' element={<PersonPitcher data={data} loading={loading} />} />
       <Route path='/personal-batter' element={<PersonBatter data={data} loading={loading} />} />
       <Route path='*' element={<Navigate to='leaderboard-batter' />} />
     </Routes>
     <Footer />
    </div>
  );
}

export default App;
